import React from "react";
import { FaInfoCircle } from 'react-icons/fa';

// OptionsForBooking هي عنوان هالكومبوننت

function title({title,price,sett}) {
  return (
    <div className="flex justify-between items-center mb-2">
      <h5 className="md:text-xl text-lg font-medium flex items-center gap-2">
        {title} <FaInfoCircle className="w-[20px] h-[20px]" />
      </h5>
      <input
          onClick={()=>{sessionStorage.setItem("price2",price)
            sett(price)
          }}
          className="accent-[#a47a24] w-[24px] h-[24px] outline-none border-none cursor-pointer"
          type="radio"
          name="spa1"
          id=""
        />
    </div>
  );
}

export default title;
